/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFEmailLeakAggregatedEvent } from './CRSFEmailLeakAggregatedEvent';
import {
    CRSFEmailLeakAggregatedEventFromJSON,
    CRSFEmailLeakAggregatedEventFromJSONTyped,
    CRSFEmailLeakAggregatedEventToJSON,
} from './CRSFEmailLeakAggregatedEvent';

/**
 * 
 * @export
 * @interface CRSFEmailLeaksAggregatedResponse
 */
export interface CRSFEmailLeaksAggregatedResponse {
    /**
     * 
     * @type {Array<CRSFEmailLeakAggregatedEvent>}
     * @memberof CRSFEmailLeaksAggregatedResponse
     */
    events: Array<CRSFEmailLeakAggregatedEvent>;
    /**
     * 
     * @type {string}
     * @memberof CRSFEmailLeaksAggregatedResponse
     */
    query: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFEmailLeaksAggregatedResponse
     */
    total: number;
}

/**
 * Check if a given object implements the CRSFEmailLeaksAggregatedResponse interface.
 */
export function instanceOfCRSFEmailLeaksAggregatedResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "events" in value;
    isInstance = isInstance && "query" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function CRSFEmailLeaksAggregatedResponseFromJSON(json: any): CRSFEmailLeaksAggregatedResponse {
    return CRSFEmailLeaksAggregatedResponseFromJSONTyped(json, false);
}

export function CRSFEmailLeaksAggregatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFEmailLeaksAggregatedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(CRSFEmailLeakAggregatedEventFromJSON)),
        'query': json['query'],
        'total': json['total'],
    };
}

export function CRSFEmailLeaksAggregatedResponseToJSON(value?: CRSFEmailLeaksAggregatedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'events': ((value.events as Array<any>).map(CRSFEmailLeakAggregatedEventToJSON)),
        'query': value.query,
        'total': value.total,
    };
}

